import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    IMultiCapabilityTemplateInfo,
    ITemplateQuestionInfo,
    QuestionOperateType,
    IOperateConfig,
    QuestionType,
    TemplateType,
    VIEW_MODE,
} from '../../interface/multiCapabilityTemplate';
import { QuestionList } from '../questionList';
import { lang } from '@umu/ukit-lang';
import { If } from 'common/src/components';
import { Button, Modal, UmuInput } from '@umu/umu-design';
import { operateList, internalList, onUpdateQuestionListIndex } from './dataFlow';
import { BatchQuestion } from '../batchQuestion';
import { getQuestionDefaultData } from '../batchQuestion/dataFlow';
interface IProps {
    preCls?: string;
    isValid: boolean;
    info: IMultiCapabilityTemplateInfo;
    mode: VIEW_MODE;
    tmpRef: any;
    onChange: (data: IMultiCapabilityTemplateInfo) => void;
}

const { confirm } = Modal;

const TemplateInfo = (props: IProps) => {
    const { preCls = 'multi-capability-template-detail-info', info, isValid, mode, tmpRef, onChange } = props;
    const { list: defaultList = [], parent_type = TemplateType.MY } = info;
    const [list, setList] = useState(onUpdateQuestionListIndex(defaultList));
    const [operateConfig, setOperateConfig] = useState<IOperateConfig>({
        isShow: false,
        index: -1,
        type: QuestionOperateType.MOVE,
    });
    const [title, setTitle] = useState(info.title || '');
    const isView = mode === VIEW_MODE.VIEW;
    const onListChange = (list: ITemplateQuestionInfo[]) => {
        setList(onUpdateQuestionListIndex(list));
    };
    useEffect(() => {
        onChange({
            ...info,
            title,
            list,
            paragraph_num: list.filter((item) => item.type === QuestionType.PARAGRAPH).length,
            question_num: list.filter((item) => item.type !== QuestionType.PARAGRAPH).length,
        });
    }, [list, title]);
    const onBatchClick = () => {
        let result: any[] = [];
        const dialog = confirm({
            title: lang('批量添加问题'),
            centered: true,
            width: '8.6rem',
            cancelText: false,
            okText: lang('添加问题'),
            okButtonProps: {
                disabled: true,
            },
            content: (
                <BatchQuestion
                    onChange={(data) => {
                        const { questionList = [] } = data;
                        result = questionList;
                        dialog.update({
                            okButtonProps: {
                                disabled: !result.length,
                            },
                        });
                    }}
                />
            ),
            onOk: () => {
                const newList = [...list].concat(result);
                onListChange(newList);
            },
        });
    };
    const onUpdateItem = (index: number, data: any) => {
        const tmpItem = list[index];
        list[index] = {
            ...tmpItem,
            ...data,
        };
        onListChange(list);
    };
    const onDelQuestion = (index: number) => {
        confirm({
            title: lang('确认要删除此问题吗？'),
            okText: lang('确认'),
            closable: false,
            centered: true,
            cancelText: lang('取消'),
            onOk() {
                const newList = [...list];
                newList.splice(index, 1);
                onListChange(newList);
            },
        });
    };
    const onCommunication = (type: QuestionOperateType, data: any) => {
        const { index, ...rest } = data;
        switch (type) {
            case QuestionOperateType.CHANGE_CONFIG:
                onUpdateItem(index, rest);
                break;
            case QuestionOperateType.COPY:
            case QuestionOperateType.MOVE:
                if (!operateConfig.isShow) {
                    setOperateConfig({
                        isShow: true,
                        index,
                        type,
                    });
                }
                break;
            case QuestionOperateType.MOVE_TO:
                const currentInfo = list[operateConfig.index];
                list.splice(operateConfig.index, 1);
                const endIndex = data.index > operateConfig.index ? data.index - 1 : data.index;
                list.splice(endIndex, 0, currentInfo);
                onListChange(list);
                onCommunication(QuestionOperateType.CANCEL_OPERATE, {});
                break;
            case QuestionOperateType.COPY_TO:
                const copyInfo = list[operateConfig.index];
                const copyList = [...list];
                copyList.splice(data.index, 0, copyInfo);
                onListChange(copyList);
                onCommunication(QuestionOperateType.CANCEL_OPERATE, {});
                break;
            case QuestionOperateType.CANCEL_OPERATE:
                setOperateConfig({
                    isShow: false,
                    index: -1,
                    type: QuestionOperateType.MOVE,
                });
                break;
            case QuestionOperateType.DELETE:
                onDelQuestion(data.index);
                break;
            case QuestionOperateType.ADD:
                const { tmpInfo } = data;
                list.splice(index, 0, tmpInfo);
                onListChange(list);
                break;
            case QuestionOperateType.UPDATE_IMG:
                onUpdateItem(index, {
                    extend: {
                        ...list[index]?.extend,
                        resource_arr: data?.resourceInfo
                            ? [
                                  {
                                      resource_type: 11,
                                      resource_id: '',
                                      resource_data: data.resourceInfo,
                                  },
                              ]
                            : [],
                    },
                });
                break;
        }
        return Promise.resolve(true);
    };
    return (
        <div className={`${preCls} ${isView ? 'view' : 'editor'} template-${info.parent_type}`} ref={tmpRef}>
            <div className={`${preCls}-heard`}>
                <div className="capability-flex-col capability-space-between view-hide">
                    <span className="is-require">{lang('标题')}</span>
                    <Button type="text" isOnlyChildren onClick={onBatchClick}>
                        {lang('批量添加问题')}
                    </Button>
                </div>
                <div className="editor-hide large-title capability-title">{title}</div>
                <UmuInput
                    className="view-hide"
                    value={title}
                    onChange={(e) => setTitle(e.value)}
                    expandConfig={{ placeholder: lang('请填写评价标准名称') }}
                ></UmuInput>
                <If condition={isValid}>
                    <div>
                        {title === '' && <div className="valid-text">{lang('请输入标题')}</div>}
                        {title && !list.length && <div className="valid-text">{lang('至少需要设置一个问题。')}</div>}
                    </div>
                </If>
            </div>
            <div className={`${preCls}-question-list`}>
                <QuestionList
                    mode={mode}
                    list={list}
                    isValid={isValid}
                    operateConfig={operateConfig}
                    templateType={parent_type}
                    externalList={operateList}
                    internalList={internalList}
                    onCommunication={onCommunication}
                />
            </div>
            <div className="footer-list capability-flex-col template-detail-footer view-hide">
                <Button
                    type="ghost"
                    iconName="AddSmall"
                    onClick={() =>
                        onCommunication(QuestionOperateType.ADD, {
                            index: list.length,
                            tmpInfo: getQuestionDefaultData(QuestionType.RADIO),
                        })
                    }
                >
                    {lang('添加问题')}
                </Button>
                <Button
                    type="ghost-grey"
                    iconName="AddSmall"
                    className="btn-split"
                    onClick={() =>
                        onCommunication(QuestionOperateType.ADD, {
                            index: list.length,
                            tmpInfo: getQuestionDefaultData(QuestionType.PARAGRAPH),
                        })
                    }
                >
                    {lang('添加段落说明')}
                </Button>
                <Button type="text" className="btn-split footer-text-link" isOnlyChildren onClick={onBatchClick}>
                    {lang('批量添加问题')}
                </Button>
            </div>
        </div>
    );
};

export { TemplateInfo };
